var map = {
	"./JLPT學院.png": "e2bc",
	"./商業英文.png": "2e65",
	"./多益專區.png": "e8934",
	"./學習資源.png": "8cba",
	"./寫作專區.png": "050c",
	"./必學日語.png": "778b",
	"./文化日語.png": "066b",
	"./新聞英語.png": "d521",
	"./旅遊日語.png": "9834",
	"./生活日語.png": "0ae4",
	"./生活英文.png": "a658",
	"./職場日語.png": "8109",
	"./雅思專區.png": "515e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5be1";